import { Injectable } from '@angular/core';
import Swal from 'sweetalert2';
import { Observable, Observer, BehaviorSubject } from 'rxjs';

export type ToastType = 'success' | 'error';

export interface ToastData {
  title: string;
  message: string;
  type: ToastType;
}

@Injectable({
  providedIn: 'root'
})

export class AlertService {

  private toastSubject = new BehaviorSubject<ToastData | null>(null);
  toast$ = this.toastSubject.asObservable();
  readonly duration = 3000;

  constructor() { }

  successAlert(message: any) {
    this.show({
      title: 'Success!',
      message: typeof message === 'string' ? message : (message?.message || JSON.stringify(message)),
      type: 'success'
    });
  }

  failureAlert(message: any) {
    this.show({
      title: 'Failed!',
      message: typeof message === 'string' ? message : (message?.message || JSON.stringify(message)),
      type: 'error'
    });
  }

  toastSuccess(message: any) {
    this.show({
      title: 'Success!',
      message: typeof message === 'string' ? message : (message?.message || JSON.stringify(message)),
      type: 'success'
    });
  }

  toastFailure(message: any) {
    this.show({
      title: 'Failed!',
      message: typeof message === 'string' ? message : (message?.message || JSON.stringify(message)),
      type: 'error'
    });
  }

  private show(toast: ToastData) {
    this.toastSubject.next(toast);

    setTimeout(() => {
      this.hide();
    }, this.duration);
  }

  hide() {
    this.toastSubject.next(null);
  }

  successfulAlert(message: any): Observable<string> {
    return new Observable<string>((observer: Observer<string>) => {
      Swal.fire({
        title: 'Success!',
        text: typeof message === 'string' ? message : (message?.message || JSON.stringify(message)),
        icon: 'success',
        confirmButtonText: 'Okay',
        showConfirmButton: true,
        allowOutsideClick: false,
        showClass: {
          popup: 'animate__animated animate__fadeInDown'
        },
        hideClass: {
          popup: 'animate__animated animate__fadeOutUp'
        },
      }).then((result) => {
        if (result.isConfirmed) {
          observer.next('confirm');
          observer.complete();
        } else {
          observer.next('dismiss');
          observer.complete();
        }
      });
    });
  }
  confirmAlert(message: any): Observable<string> {
    return new Observable<string>((observer: Observer<string>) => {
      Swal.fire({
        title: 'Are You Sure?',
        text: message,
        icon: 'warning',
        confirmButtonText: 'Confirm',
        denyButtonText: 'Cancel',
        showDenyButton: true,
        confirmButtonColor: '#00b3fe',
        showClass: {
          popup: 'animate__animated animate__fadeInDown'
        },
        hideClass: {
          popup: 'animate__animated animate__fadeOutUp'
        }
      }).then((result) => {
        if (result.isConfirmed) {
          observer.next('confirm');
          observer.complete();
        } else if (result.isDenied) {
          observer.next('cancel');
          observer.complete();
        } else {
          observer.next('dismiss');
          observer.complete();
        }
      });
    });
  }

  importatAlert(message: any): Observable<string> {
    return new Observable<string>((observer: Observer<string>) => {
      Swal.fire({
        title: 'Confirm Delete',
        text: message,
        icon: 'warning',
        confirmButtonText: 'Delete',
        denyButtonText: 'Cancel',
        showDenyButton: true,
        confirmButtonColor: '#00b3fe',
        showClass: {
          popup: 'animate__animated animate__fadeInDown'
        },
        hideClass: {
          popup: 'animate__animated animate__fadeOutUp'
        }
      }).then((result) => {
        if (result.isConfirmed) {
          observer.next('confirm');
          observer.complete();
        } else if (result.isDenied) {
          observer.next('cancel');
          observer.complete();
        } else {
          observer.next('dismiss');
          observer.complete();
        }
      });
    });
  }

  warningAlert(message: any) {
    Swal.fire({
      title: 'Warning',
      text: message,
      icon: 'warning',
      confirmButtonText: 'Okay',
      showConfirmButton: true,
      allowOutsideClick: false,
      showClass: {
        popup: 'animate__animated animate__fadeInDown'
      },
      hideClass: {
        popup: 'animate__animated animate__fadeOutUp'
      }
    })
  }

  warningDateAlert(message: any) {
    return Swal.fire({
      title: 'Warning',
      text: message,
      icon: 'warning',
      confirmButtonText: 'Okay',
      showConfirmButton: true,
      allowOutsideClick: false,
      showClass: {
        popup: 'animate__animated animate__fadeInDown'
      },
      hideClass: {
        popup: 'animate__animated animate__fadeOutUp'
      }
    });
  }

}
